export { default } from './MarketingPageLayoutContent.js';
